<h1 mat-dialog-title>{{ data.title }}</h1>

<div mat-dialog-content>
    <div class="warning-banner">
        <mat-icon>warning</mat-icon>
        <p>{{ data.body }}</p>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">{{ data.cancelLabel || 'Cancel' }}</button>
    <button mat-flat-button color="primary" (click)="confirm()">{{ data.confirmLabel || 'Confirm' }}</button>
</div>
